var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registrationBox"},[_c('div',[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":_vm.yes,"alt":""}})]),_c('p',[_vm._v("您的报名材料已提交成功，资格初审结果请登录系统后在“个人报名记录”中查询详细信息。如有疑问，可在工作时间电话咨询。")])])])}
var staticRenderFns = []

export { render, staticRenderFns }